
import React from 'react';
import { Progress } from "@/components/ui/progress";

interface ProgressBarProps {
  current: number;
  total: number;
  correctAnswers: number;
  totalInTopic?: number; // Optional total questions in topic
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
  current, 
  total, 
  correctAnswers,
  totalInTopic
}) => {
  const progressPercent = (current / total) * 100;
  
  return (
    <div className="w-full max-w-2xl mx-auto mb-6">
      <div className="flex justify-between items-center mb-2">
        <div className="text-sm text-muted-foreground">
          Question {current} of {total} 
          {totalInTopic && totalInTopic > total && (
            <span className="ml-1 text-xs text-muted-foreground">
              (from {totalInTopic} total)
            </span>
          )}
        </div>
        <div className="text-sm font-medium">
          Score: {correctAnswers} correct
        </div>
      </div>
      <Progress value={progressPercent} className="h-2" />
    </div>
  );
};

export default ProgressBar;
